import type { Resolvers } from "@apollo/client/core/types.js";

const resolvers: Resolvers = {};

export default resolvers;
